import { render, staticRenderFns } from "./Lgx03654589120261633472578.vue?vue&type=template&id=32d65a69&"
import script from "./Lgx03654589120261633472578.vue?vue&type=script&lang=js&"
export * from "./Lgx03654589120261633472578.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports